export default __webpack_public_path__ + "static/media/virtualfolder.83fb1e72.jpg";